import {makeActionCreator} from '../utility'

export const FETCH_MEMBERSHIP_REPORTS = 'FETCH_MEMBERSHIP_REPORTS'
export const fetchMembershipreports = makeActionCreator(FETCH_MEMBERSHIP_REPORTS,'data')

export const FETCH_MEMBERSHIP_REPORTS_RECEIVED = 'FETCH_MEMBERSHIP_REPORTS_RECEIVED'
export const fetchMembershipreportsReceived = makeActionCreator(FETCH_MEMBERSHIP_REPORTS_RECEIVED,'data')